import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const getToken = () => localStorage.getItem("token");


export const FETCH_CONTACT_REQUEST = "FETCH_CONTACT_REQUEST";
export const FETCH_CONTACT_SUCCESS = "FETCH_CONTACT_SUCCESS";
export const FETCH_CONTACT_FAILURE = "FETCH_CONTACT_FAILURE";

export const FETCH_RESUME_REQUEST = "FETCH_RESUME_REQUEST";
export const FETCH_RESUME_SUCCESS = "FETCH_RESUME_SUCCESS";
export const FETCH_RESUME_FAILURE = "FETCH_RESUME_FAILURE";

export const DELETE_MESSAGE_REQUEST = "DELETE_MESSAGE_REQUEST";
export const DELETE_MESSAGE_SUCCESS = "DELETE_MESSAGE_SUCCESS";
export const DELETE_MESSAGE_FAILURE = "DELETE_MESSAGE_FAILURE";



// Fetch Contact Messages
export const fetchContacts = () => async (dispatch) => {
  dispatch({ type: FETCH_CONTACT_REQUEST });
  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/admin/getContactMessages`,
      {
        headers: {
          Authorization: getToken(),
        },
      }
    );

    dispatch({
      type: FETCH_CONTACT_SUCCESS,
      payload: response.data?.data || [],
    });
  } catch (error) {
    dispatch({
      type: FETCH_CONTACT_FAILURE,
      payload: error.message,
    });
    toast.error("Failed to fetch contact messages");
  }
};

// Fetch Resume Applications
export const fetchResumes = () => async (dispatch) => {
  dispatch({ type: FETCH_RESUME_REQUEST });
  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/admin/getJobApplications`,
      {
        headers: {
          Authorization: getToken(),
        },
      }
    );

    dispatch({
      type: FETCH_RESUME_SUCCESS,
      payload: response.data?.data || [],
    });
  } catch (error) {
    dispatch({
      type: FETCH_RESUME_FAILURE,
      payload: error.message,
    });
    toast.error("Failed to fetch resume applications");
  }
};

// Delete Contact / Resume
export const deleteMessage = (url, id) => async (dispatch) => {
  dispatch({ type: DELETE_MESSAGE_REQUEST });
  try {
    await axios.delete(`${BASE_URL}${url}/${id}`, {
      headers: {
        Authorization: getToken(),
      },
    });

    dispatch({
      type: DELETE_MESSAGE_SUCCESS,
      payload: id,
    });

    toast.success("Deleted successfully");
  } catch (error) {
    dispatch({
      type: DELETE_MESSAGE_FAILURE,
      payload: error.message,
    });
    toast.error("Delete failed");
  }
};
